const currency = {
  default: "tr-TR",
  options: {
    TRY: ["tr-TR", "tr"],
    USD: ["en-US"],
    BRL: ["pt-BR"],
    EUR: ["es-ES", "fr-FR", "it-IT", "de-DE"],
  },
};

export default currency;
